/**
 * The one basemap every map in the app uses: CARTO "dark_all" raster tiles.
 *
 * CARTO's basemap service requires an API key (since September 2026; without
 * one every tile is an "API KEY REQUIRED" image). The key is baked in at build
 * time from REACT_APP_CARTO_API_KEY, which `make platform-build` reads from
 * SSM `<env prefix>/CARTO_BASEMAPS_API_KEY` and verifies in the emitted
 * bundle. The key is public by nature (it is in every tile URL the browser
 * requests); it lives in SSM so no build or commit hardcodes it.
 */
const KEY = process.env.REACT_APP_CARTO_API_KEY || "";
const q = KEY ? `?key=${encodeURIComponent(KEY)}` : "";

if (!KEY && process.env.NODE_ENV !== "test") {
  // Loud in the console rather than silent grey tiles.
  // eslint-disable-next-line no-console
  console.error("REACT_APP_CARTO_API_KEY is not set: map tiles will show CARTO's 'API KEY REQUIRED' notice.");
}

/** Leaflet TileLayer url ({s} subdomains, {r} retina suffix). */
export const CARTO_DARK_URL = `https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png${q}`;

/** MapLibre raster source tiles (explicit subdomains, @2x). */
export const CARTO_DARK_TILES_2X = ["a", "b", "c"].map(
  (s) => `https://${s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}@2x.png${q}`,
);

export const CARTO_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>';
